// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Layout Styles */
.admin-layout {
  min-height: 100vh;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
}

/* Admin Header */
.admin-header {
  background: linear-gradient(135deg, #1e293b, #334155);
  color: white;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.admin-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 100%;
}

.admin-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.admin-sidebar-toggle {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background-color 0.2s;
}

.admin-sidebar-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.admin-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
}

.admin-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.admin-user-info {
  color: #cbd5e1;
  font-size: 0.875rem;
}

/* Admin Buttons */
.admin-btn {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-btn-primary {
  background-color: #2563eb;
  color: white;
}

.admin-btn-primary:hover {
  background-color: #1d4ed8;
}

.admin-btn-secondary {
  background-color: #475569;
  color: white;
}

.admin-btn-secondary:hover {
  background-color: #64748b;
}

.admin-btn-danger {
  background-color: #dc2626;
  color: white;
}

.admin-btn-danger:hover {
  background-color: #b91c1c;
}

.admin-btn-warning {
  background-color: #f59e0b;
  color: white;
}

.admin-btn-warning:hover {
  background-color: #d97706;
}

.admin-btn-warning:disabled {
  background-color: #fbbf24;
  opacity: 0.6;
  cursor: not-allowed;
}

/* Admin Main Layout */
.admin-main {
  display: flex;
  flex: 1 1;
  min-height: calc(100vh - 80px);
}

/* Admin Sidebar */
.admin-sidebar {
  width: 280px;
  background-color: white;
  border-right: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  overflow-y: auto;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
}

.admin-sidebar.closed {
  width: 0;
  overflow: hidden;
}

.admin-nav {
  padding: 1rem 0;
}

.admin-nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  color: #64748b;
  text-decoration: none;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.admin-nav-item:hover {
  background-color: #f1f5f9;
  color: #1e293b;
}

.admin-nav-item.active {
  background-color: #eff6ff;
  color: #2563eb;
  border-left-color: #2563eb;
  font-weight: 600;
}

.admin-nav-icon {
  font-size: 1.25rem;
  width: 1.5rem;
  text-align: center;
}

.admin-nav-label {
  font-size: 0.875rem;
  font-weight: 500;
}

/* Admin Content */
.admin-content {
  flex: 1 1;
  background-color: #f8fafc;
  overflow-y: auto;
}

.admin-content-wrapper {
  padding: 2rem;
  max-width: 100%;
}

/* Admin Cards */
.admin-card {
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  margin-bottom: 1.5rem;
}

.admin-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.admin-card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.admin-card-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

/* Admin Tables */
.admin-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.admin-table th {
  background-color: #f8fafc;
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.875rem;
}

.admin-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 0.875rem;
}

.admin-table tr:hover {
  background-color: #f8fafc;
}

/* Admin Stats */
.admin-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.admin-stat-card {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.admin-stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.admin-stat-label {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.admin-stat-change {
  font-size: 0.75rem;
  font-weight: 500;
}

.admin-stat-change.positive {
  color: #059669;
}

.admin-stat-change.negative {
  color: #dc2626;
}

/* Admin Forms */
.admin-form {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.admin-form-group {
  margin-bottom: 1.5rem;
}

.admin-form-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.admin-form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: border-color 0.2s;
}

.admin-form-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.admin-form-select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  background-color: white;
  cursor: pointer;
}

/* Admin Inline Select Styles */
.admin-inline-select {
  width: auto !important;
  min-width: 80px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.admin-inline-select:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.admin-inline-select:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.admin-role-select {
  background-color: #2563eb;
  color: white;
}

.admin-role-select option {
  background-color: white;
  color: #374151;
}

.admin-status-select {
  background-color: #059669;
  color: white;
}

.admin-status-select option {
  background-color: white;
  color: #374151;
}

/* Admin Dashboard Styles */
.admin-dashboard {
  max-width: 100%;
}

.admin-activities {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.admin-activity-item {
  padding: 1rem;
  background-color: #f8fafc;
  border-radius: 0.375rem;
  border-left: 3px solid #2563eb;
}

.admin-activity-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.admin-activity-message {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}

.admin-activity-time {
  font-size: 0.75rem;
  color: #6b7280;
}

.admin-quick-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.admin-stat-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

/* Admin Users Styles */
.admin-users {
  max-width: 100%;
}

.admin-filters {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 1.5rem;
  align-items: end;
}

.admin-table-container {
  overflow-x: auto;
}

.admin-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
}

.admin-actions {
  display: flex;
  gap: 0.5rem;
}

.admin-btn-small {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
}

/* Admin Tournaments Styles */
.admin-tournaments {
  max-width: 100%;
}

.admin-tournament-name {
  font-weight: 600;
  color: #1e293b;
}

/* Admin Players Styles */
.admin-players {
  max-width: 100%;
}

.admin-player-name {
  font-weight: 600;
  color: #1e293b;
}

.admin-owgr-rank {
  font-weight: 600;
  color: #2563eb;
  background-color: #eff6ff;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
}

.admin-tier-badge {
  font-weight: 700;
  font-size: 0.75rem;
}

/* Admin Notifications */
.admin-notification {
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid;
  font-weight: 500;
}

.admin-notification-info {
  background-color: #eff6ff;
  color: #1e40af;
  border-color: #bfdbfe;
}

.admin-notification-success {
  background-color: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.admin-notification-warning {
  background-color: #fffbeb;
  color: #92400e;
  border-color: #fed7aa;
}

.admin-notification-error {
  background-color: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.admin-notification-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.admin-notification-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}

.admin-notification span:not(.admin-notification-icon) {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* Analytics Section Text Visibility */
.analytics-section {
  color: #1e293b !important;
}

.analytics-section h1,
.analytics-section h2,
.analytics-section h3,
.analytics-section h4,
.analytics-section h5,
.analytics-section h6 {
  color: #1e293b !important;
}

.analytics-section p,
.analytics-section span,
.analytics-section div {
  color: #374151 !important;
}

.analytics-section .admin-card-title {
  color: #1e293b !important;
}

.analytics-section .admin-card-subtitle {
  color: #64748b !important;
}

.analytics-section .admin-stat-label {
  color: #64748b !important;
}

.analytics-section .admin-stat-value {
  color: #1e293b !important;
}

.analytics-section .admin-stat-change {
  color: #6b7280 !important;
}

.analytics-section .admin-table th {
  color: #374151 !important;
}

.analytics-section .admin-table td {
  color: #64748b !important;
}

.analytics-section .admin-badge {
  color: white !important;
}

.analytics-section .selection-card h2 {
  color: #1f2937 !important;
}

.analytics-section .selection-card p {
  color: #6b7280 !important;
}

.analytics-section .selection-card li {
  color: #374151 !important;
}

.analytics-section .tournament-selection-message {
  color: #1e293b !important;
}

.analytics-section .tournament-financial-overview {
  color: #1e293b !important;
}

.analytics-section .tournament-info-header h2 {
  color: #1f2937 !important;
}

.analytics-section .tournament-meta {
  color: #6b7280 !important;
}

.analytics-section .tournament-meta strong {
  color: #374151 !important;
}

.analytics-section .metric-detail {
  color: #6b7280 !important;
}

.analytics-section .tier-revenue {
  color: #1f2937 !important;
}

.analytics-section .tier-percentage {
  color: #6b7280 !important;
}

.analytics-section .wins-summary span {
  color: #374151 !important;
}

.analytics-section .wins-summary strong {
  color: #1f2937 !important;
}

.analytics-section .win-holes {
  color: #374151 !important;
}

.analytics-section .win-hole {
  color: #1e293b !important;
}

.analytics-section .distribution-calculation {
  color: #374151 !important;
}

.analytics-section .calc-row {
  color: #374151 !important;
}

.analytics-section .summary-item span:first-child {
  color: #374151 !important;
}

.analytics-section .summary-item span:last-child {
  color: #059669 !important;
}

.analytics-section .admin-form-select {
  color: #374151 !important;
  background-color: white !important;
}

.analytics-section .admin-btn {
  color: white !important;
}

.analytics-section .admin-btn-secondary {
  color: white !important;
  background-color: #475569 !important;
}

.analytics-section .admin-btn-primary {
  color: white !important;
  background-color: #2563eb !important;
}

.analytics-section .loading-spinner {
  color: #64748b !important;
}

.analytics-section .error-message {
  color: #dc2626 !important;
}

.analytics-section .no-data {
  color: #6b7280 !important;
}

/* Admin Modal Styles */
.admin-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.admin-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.admin-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.admin-modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
}

.admin-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.admin-modal-close:hover:not(:disabled) {
  background-color: #f3f4f6;
  color: #1f2937;
}

.admin-modal-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.admin-modal-body {
  padding: 20px;
  color: #374151;
}

.admin-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #e5e7eb;
}

/* Pagination Styles */
.admin-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-top: 1px solid #e2e8f0;
  margin-top: 1rem;
}

.admin-pagination-info {
  color: #64748b;
  font-size: 0.875rem;
}

.admin-pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-pagination-pages {
  display: flex;
  gap: 0.25rem;
}

.admin-btn-pagination {
  min-width: 2.5rem;
  height: 2.5rem;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  background-color: white;
  color: #374151;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-btn-pagination:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.admin-btn-pagination.active {
  background-color: #3b82f6;
  border-color: #3b82f6;
  color: white;
}

.admin-btn-pagination.active:hover {
  background-color: #2563eb;
  border-color: #2563eb;
}

.admin-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.admin-btn:disabled:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

/* Sortable table headers */
.sortable:hover {
  background-color: #f8fafc;
}

/* Responsive Design */
@media (max-width: 768px) {
  .admin-header-content {
    padding: 1rem;
  }
  
  .admin-title {
    font-size: 1.25rem;
  }
  
  .admin-header-right {
    gap: 0.5rem;
  }
  
  .admin-user-info {
    display: none;
  }
  
  .admin-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    height: calc(100vh - 80px);
    z-index: 50;
    transform: translateX(-100%);
  }
  
  .admin-sidebar.open {
    transform: translateX(0);
  }
  
  .admin-content-wrapper {
    padding: 1rem;
  }
  
  .admin-stats {
    grid-template-columns: 1fr;
  }
  
  .admin-pagination {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .admin-pagination-controls {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .admin-header-content {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .admin-header-right {
    width: 100%;
    justify-content: space-between;
  }
  
  .admin-content-wrapper {
    padding: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/AdminLayout.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,YAAY;EACZ,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAO;EACP,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Admin Layout Styles */\n.admin-layout {\n  min-height: 100vh;\n  background-color: #f8fafc;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Admin Header */\n.admin-header {\n  background: linear-gradient(135deg, #1e293b, #334155);\n  color: white;\n  padding: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.admin-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  max-width: 100%;\n}\n\n.admin-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.admin-sidebar-toggle {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s;\n}\n\n.admin-sidebar-toggle:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.admin-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  color: white;\n}\n\n.admin-header-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.admin-user-info {\n  color: #cbd5e1;\n  font-size: 0.875rem;\n}\n\n/* Admin Buttons */\n.admin-btn {\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-btn-primary {\n  background-color: #2563eb;\n  color: white;\n}\n\n.admin-btn-primary:hover {\n  background-color: #1d4ed8;\n}\n\n.admin-btn-secondary {\n  background-color: #475569;\n  color: white;\n}\n\n.admin-btn-secondary:hover {\n  background-color: #64748b;\n}\n\n.admin-btn-danger {\n  background-color: #dc2626;\n  color: white;\n}\n\n.admin-btn-danger:hover {\n  background-color: #b91c1c;\n}\n\n.admin-btn-warning {\n  background-color: #f59e0b;\n  color: white;\n}\n\n.admin-btn-warning:hover {\n  background-color: #d97706;\n}\n\n.admin-btn-warning:disabled {\n  background-color: #fbbf24;\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Admin Main Layout */\n.admin-main {\n  display: flex;\n  flex: 1;\n  min-height: calc(100vh - 80px);\n}\n\n/* Admin Sidebar */\n.admin-sidebar {\n  width: 280px;\n  background-color: white;\n  border-right: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  overflow-y: auto;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);\n}\n\n.admin-sidebar.closed {\n  width: 0;\n  overflow: hidden;\n}\n\n.admin-nav {\n  padding: 1rem 0;\n}\n\n.admin-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1.5rem;\n  color: #64748b;\n  text-decoration: none;\n  transition: all 0.2s;\n  border-left: 3px solid transparent;\n}\n\n.admin-nav-item:hover {\n  background-color: #f1f5f9;\n  color: #1e293b;\n}\n\n.admin-nav-item.active {\n  background-color: #eff6ff;\n  color: #2563eb;\n  border-left-color: #2563eb;\n  font-weight: 600;\n}\n\n.admin-nav-icon {\n  font-size: 1.25rem;\n  width: 1.5rem;\n  text-align: center;\n}\n\n.admin-nav-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n/* Admin Content */\n.admin-content {\n  flex: 1;\n  background-color: #f8fafc;\n  overflow-y: auto;\n}\n\n.admin-content-wrapper {\n  padding: 2rem;\n  max-width: 100%;\n}\n\n/* Admin Cards */\n.admin-card {\n  background: white;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n  margin-bottom: 1.5rem;\n}\n\n.admin-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.admin-card-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n}\n\n.admin-card-subtitle {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin: 0;\n}\n\n/* Admin Tables */\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.admin-table th {\n  background-color: #f8fafc;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 0.875rem;\n}\n\n.admin-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: #64748b;\n  font-size: 0.875rem;\n}\n\n.admin-table tr:hover {\n  background-color: #f8fafc;\n}\n\n/* Admin Stats */\n.admin-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.admin-stat-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.admin-stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n}\n\n.admin-stat-label {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 0.25rem;\n}\n\n.admin-stat-change {\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.admin-stat-change.positive {\n  color: #059669;\n}\n\n.admin-stat-change.negative {\n  color: #dc2626;\n}\n\n/* Admin Forms */\n.admin-form {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.admin-form-group {\n  margin-bottom: 1.5rem;\n}\n\n.admin-form-label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.admin-form-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s;\n}\n\n.admin-form-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.admin-form-select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  background-color: white;\n  cursor: pointer;\n}\n\n/* Admin Inline Select Styles */\n.admin-inline-select {\n  width: auto !important;\n  min-width: 80px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.admin-inline-select:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.admin-inline-select:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.admin-role-select {\n  background-color: #2563eb;\n  color: white;\n}\n\n.admin-role-select option {\n  background-color: white;\n  color: #374151;\n}\n\n.admin-status-select {\n  background-color: #059669;\n  color: white;\n}\n\n.admin-status-select option {\n  background-color: white;\n  color: #374151;\n}\n\n/* Admin Dashboard Styles */\n.admin-dashboard {\n  max-width: 100%;\n}\n\n.admin-activities {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.admin-activity-item {\n  padding: 1rem;\n  background-color: #f8fafc;\n  border-radius: 0.375rem;\n  border-left: 3px solid #2563eb;\n}\n\n.admin-activity-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.admin-activity-message {\n  font-size: 0.875rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.admin-activity-time {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.admin-quick-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.admin-stat-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n/* Admin Users Styles */\n.admin-users {\n  max-width: 100%;\n}\n\n.admin-filters {\n  display: grid;\n  grid-template-columns: 1fr 200px;\n  gap: 1.5rem;\n  align-items: end;\n}\n\n.admin-table-container {\n  overflow-x: auto;\n}\n\n.admin-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n}\n\n.admin-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.admin-btn-small {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n}\n\n/* Admin Tournaments Styles */\n.admin-tournaments {\n  max-width: 100%;\n}\n\n.admin-tournament-name {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Admin Players Styles */\n.admin-players {\n  max-width: 100%;\n}\n\n.admin-player-name {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.admin-owgr-rank {\n  font-weight: 600;\n  color: #2563eb;\n  background-color: #eff6ff;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n}\n\n.admin-tier-badge {\n  font-weight: 700;\n  font-size: 0.75rem;\n}\n\n/* Admin Notifications */\n.admin-notification {\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  border: 1px solid;\n  font-weight: 500;\n}\n\n.admin-notification-info {\n  background-color: #eff6ff;\n  color: #1e40af;\n  border-color: #bfdbfe;\n}\n\n.admin-notification-success {\n  background-color: #f0fdf4;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.admin-notification-warning {\n  background-color: #fffbeb;\n  color: #92400e;\n  border-color: #fed7aa;\n}\n\n.admin-notification-error {\n  background-color: #fef2f2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.admin-notification-content {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.admin-notification-icon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.admin-notification span:not(.admin-notification-icon) {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n/* Analytics Section Text Visibility */\n.analytics-section {\n  color: #1e293b !important;\n}\n\n.analytics-section h1,\n.analytics-section h2,\n.analytics-section h3,\n.analytics-section h4,\n.analytics-section h5,\n.analytics-section h6 {\n  color: #1e293b !important;\n}\n\n.analytics-section p,\n.analytics-section span,\n.analytics-section div {\n  color: #374151 !important;\n}\n\n.analytics-section .admin-card-title {\n  color: #1e293b !important;\n}\n\n.analytics-section .admin-card-subtitle {\n  color: #64748b !important;\n}\n\n.analytics-section .admin-stat-label {\n  color: #64748b !important;\n}\n\n.analytics-section .admin-stat-value {\n  color: #1e293b !important;\n}\n\n.analytics-section .admin-stat-change {\n  color: #6b7280 !important;\n}\n\n.analytics-section .admin-table th {\n  color: #374151 !important;\n}\n\n.analytics-section .admin-table td {\n  color: #64748b !important;\n}\n\n.analytics-section .admin-badge {\n  color: white !important;\n}\n\n.analytics-section .selection-card h2 {\n  color: #1f2937 !important;\n}\n\n.analytics-section .selection-card p {\n  color: #6b7280 !important;\n}\n\n.analytics-section .selection-card li {\n  color: #374151 !important;\n}\n\n.analytics-section .tournament-selection-message {\n  color: #1e293b !important;\n}\n\n.analytics-section .tournament-financial-overview {\n  color: #1e293b !important;\n}\n\n.analytics-section .tournament-info-header h2 {\n  color: #1f2937 !important;\n}\n\n.analytics-section .tournament-meta {\n  color: #6b7280 !important;\n}\n\n.analytics-section .tournament-meta strong {\n  color: #374151 !important;\n}\n\n.analytics-section .metric-detail {\n  color: #6b7280 !important;\n}\n\n.analytics-section .tier-revenue {\n  color: #1f2937 !important;\n}\n\n.analytics-section .tier-percentage {\n  color: #6b7280 !important;\n}\n\n.analytics-section .wins-summary span {\n  color: #374151 !important;\n}\n\n.analytics-section .wins-summary strong {\n  color: #1f2937 !important;\n}\n\n.analytics-section .win-holes {\n  color: #374151 !important;\n}\n\n.analytics-section .win-hole {\n  color: #1e293b !important;\n}\n\n.analytics-section .distribution-calculation {\n  color: #374151 !important;\n}\n\n.analytics-section .calc-row {\n  color: #374151 !important;\n}\n\n.analytics-section .summary-item span:first-child {\n  color: #374151 !important;\n}\n\n.analytics-section .summary-item span:last-child {\n  color: #059669 !important;\n}\n\n.analytics-section .admin-form-select {\n  color: #374151 !important;\n  background-color: white !important;\n}\n\n.analytics-section .admin-btn {\n  color: white !important;\n}\n\n.analytics-section .admin-btn-secondary {\n  color: white !important;\n  background-color: #475569 !important;\n}\n\n.analytics-section .admin-btn-primary {\n  color: white !important;\n  background-color: #2563eb !important;\n}\n\n.analytics-section .loading-spinner {\n  color: #64748b !important;\n}\n\n.analytics-section .error-message {\n  color: #dc2626 !important;\n}\n\n.analytics-section .no-data {\n  color: #6b7280 !important;\n}\n\n/* Admin Modal Styles */\n.admin-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.admin-modal {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.admin-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.admin-modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.admin-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.admin-modal-close:hover:not(:disabled) {\n  background-color: #f3f4f6;\n  color: #1f2937;\n}\n\n.admin-modal-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.admin-modal-body {\n  padding: 20px;\n  color: #374151;\n}\n\n.admin-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Pagination Styles */\n.admin-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n  border-top: 1px solid #e2e8f0;\n  margin-top: 1rem;\n}\n\n.admin-pagination-info {\n  color: #64748b;\n  font-size: 0.875rem;\n}\n\n.admin-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.admin-pagination-pages {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.admin-btn-pagination {\n  min-width: 2.5rem;\n  height: 2.5rem;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  background-color: white;\n  color: #374151;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-btn-pagination:hover {\n  background-color: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.admin-btn-pagination.active {\n  background-color: #3b82f6;\n  border-color: #3b82f6;\n  color: white;\n}\n\n.admin-btn-pagination.active:hover {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.admin-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.admin-btn:disabled:hover {\n  background-color: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n/* Sortable table headers */\n.sortable:hover {\n  background-color: #f8fafc;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .admin-header-content {\n    padding: 1rem;\n  }\n  \n  .admin-title {\n    font-size: 1.25rem;\n  }\n  \n  .admin-header-right {\n    gap: 0.5rem;\n  }\n  \n  .admin-user-info {\n    display: none;\n  }\n  \n  .admin-sidebar {\n    position: fixed;\n    top: 80px;\n    left: 0;\n    height: calc(100vh - 80px);\n    z-index: 50;\n    transform: translateX(-100%);\n  }\n  \n  .admin-sidebar.open {\n    transform: translateX(0);\n  }\n  \n  .admin-content-wrapper {\n    padding: 1rem;\n  }\n  \n  .admin-stats {\n    grid-template-columns: 1fr;\n  }\n  \n  .admin-pagination {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n  \n  .admin-pagination-controls {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-header-content {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n  \n  .admin-header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .admin-content-wrapper {\n    padding: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
